"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SRStopLossProfitPercent = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const react_1 = require("react");
const Global_1 = require("../../Orders/Global");
const TradeAPILib_1 = require("TradeAPILib");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const lodash_1 = require("lodash");
const OrderCurrentTickerObserve = function (pairInfoList) {
    return (0, trade_quotation_lib_1.getGlobalQuotationSocketMgr)().getTickerWebSocket().getTickerObservableBatch(pairInfoList);
};
/**
 * 处理屯币宝止盈止损
 * @param params
 */
var SRStopLossProfitPercent;
(function (SRStopLossProfitPercent) {
    // 由数字,正负号与小数点组成的符合数字规则的字符串. 如 +3.4, -1.2, .2, +3.
    const isNumberString = (text) => /^[+-]?\d*\.?\d*$/.test(text);
    // 数字, 或数字,正负号与小数点组成的字符串
    SRStopLossProfitPercent.isValidNumber = (value) => typeof value === "number" || (typeof value === "string" && value.length > 0 && isNumberString(value));
    // 订单的操作类型, 创建 | 修改
    let OrderAction;
    (function (OrderAction) {
        OrderAction["CREATE"] = "create";
        OrderAction["MODIFY"] = "modify";
    })(OrderAction = SRStopLossProfitPercent.OrderAction || (SRStopLossProfitPercent.OrderAction = {}));
    let STOP_LIMIT_TYPE;
    (function (STOP_LIMIT_TYPE) {
        STOP_LIMIT_TYPE["LOSS_PERCENTTAGE"] = "LOSS_PERCENTTAGE";
        STOP_LIMIT_TYPE["PROFIT_PERCENTTAGE"] = "PROFIT_PERCENTTAGE";
    })(STOP_LIMIT_TYPE = SRStopLossProfitPercent.STOP_LIMIT_TYPE || (SRStopLossProfitPercent.STOP_LIMIT_TYPE = {}));
    // 给输入框中展示结果添加+/-号, 并处理展示的精度
    function displayAddSign({ value, precision = 1, }) {
        if (new trade_utils_lib_1.SafeDecimal(value).equals(0)) {
            return value;
        }
        const afterPrecision = new trade_utils_lib_1.SafeDecimal(value).toDecimalPlaces(precision, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
        let signValue = afterPrecision.greaterThan(0) ? "+" + afterPrecision.toString() : afterPrecision.toString();
        return value.endsWith(".") ? signValue + "." : signValue;
    }
    SRStopLossProfitPercent.displayAddSign = displayAddSign;
    // 检查输入的值的合法性, 并自动处理为按规则定义的字符串
    function checkValidity(
    // 输入的值, 已乘 100. 比如: +10, 表示+10%, -10, 表示-10%
    value, params) {
        const { stopLimitType, orderAction, profitPercent, isChanged, $st, $num } = params;
        // 空值的情况
        if ((0, lodash_1.isNil)(value) || value === "" || value === "+" || value === "-") {
            if (!isChanged) {
                let valueStr = value;
                if (orderAction === "create") {
                    valueStr = stopLimitType === STOP_LIMIT_TYPE.PROFIT_PERCENTTAGE ? "+" : "-";
                }
                return {
                    error: undefined,
                    isValid: true,
                    display: valueStr,
                    value: new trade_utils_lib_1.SafeDecimal(value).toString(),
                };
            }
            else {
                let valueStr = value;
                if (orderAction === "create") {
                    // 创建时禁止删除符号
                    valueStr = stopLimitType === STOP_LIMIT_TYPE.PROFIT_PERCENTTAGE ? "+" : "-";
                }
                // 为空相当于撤销止盈止损, 显示为空
                return {
                    error: undefined,
                    isValid: true,
                    display: valueStr,
                    value: "",
                };
            }
        }
        if (!isNumberString(value)) {
            return {
                error: $st("modify_price_not_number"),
                isValid: false,
                display: value,
                value: new trade_utils_lib_1.SafeDecimal(value).toString(),
            };
        }
        let valueStr = value;
        // 保留一位小数
        const sValue = new trade_utils_lib_1.SafeDecimal(new trade_utils_lib_1.SafeDecimal(valueStr).toFixed(1, trade_utils_lib_1.SafeDecimal.ROUND_DOWN));
        if (stopLimitType === STOP_LIMIT_TYPE.PROFIT_PERCENTTAGE) {
            if (orderAction === "create") {
                const display = displayAddSign({ value: valueStr, stopLimitType, $num });
                if (sValue.lessThanOrEqualTo(0)) {
                    return {
                        error: $st("modify_stop_profit_max_error", {
                            percent: $num(0, { style: "percent", precision: 1 }),
                        }),
                        isValid: false,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
                else {
                    return {
                        error: undefined,
                        isValid: true,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
            }
            else {
                const percent = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(profitPercent), 0);
                const display = displayAddSign({ value: valueStr, stopLimitType, $num });
                if (sValue.lessThanOrEqualTo(percent)) {
                    return {
                        error: $st("modify_stop_profit_max_error", {
                            percent: $num(percent.div(100).toNumber(), { style: "percent", precision: 1, sign: "always" }),
                        }),
                        isValid: false,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
                else {
                    return { error: undefined, isValid: true, display, value: new trade_utils_lib_1.SafeDecimal(display).toString() };
                }
            }
        }
        else {
            const percent = new trade_utils_lib_1.SafeDecimal(profitPercent);
            const display = displayAddSign({ value: valueStr, stopLimitType, $num });
            if (orderAction === "create") {
                if (sValue.greaterThanOrEqualTo(0)) {
                    return {
                        error: $st("modify_stop_loss_max_error", {
                            percent: 0,
                        }),
                        isValid: false,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
                else if (sValue.lessThanOrEqualTo(-100)) {
                    return {
                        error: $st("modify_stop_loss_min_error"),
                        isValid: false,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
                else {
                    return {
                        error: undefined,
                        isValid: true,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
            }
            else {
                if (sValue.greaterThanOrEqualTo(percent)) {
                    return {
                        error: $st("modify_stop_loss_max_error", {
                            percent: profitPercent
                                ? $num(new trade_utils_lib_1.SafeDecimal(profitPercent).div(100).toString(), { style: "percent", precision: 1 })
                                : "--",
                        }),
                        isValid: false,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
                else if (sValue.lessThanOrEqualTo(-100)) {
                    const display = displayAddSign({ value, stopLimitType, $num });
                    return {
                        error: $st("modify_stop_loss_min_error"),
                        isValid: false,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
                else {
                    return {
                        error: undefined,
                        isValid: true,
                        display,
                        value: new trade_utils_lib_1.SafeDecimal(display).toString(),
                    };
                }
            }
        }
    }
    SRStopLossProfitPercent.checkValidity = checkValidity;
    function useStopLossProfitPercent(params) {
        var _a;
        const { orderInfo, stopLimitType, orderAction = SRStopLossProfitPercent.OrderAction.MODIFY, defaultValue, $num, $st } = params;
        const [profitPercent, setProfitPercent] = (0, react_1.useState)("");
        const [inputValue, setInputValue] = (0, react_1.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "");
        const [inputDisplay, setInputDisplay] = (0, react_1.useState)(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "");
        const [inputError, setInputError] = (0, react_1.useState)(undefined);
        const [labelText, setLabelText] = (0, react_1.useState)("");
        const [isChanged, setIsChanged] = (0, react_1.useState)(false);
        // 初始化与卸载时
        (0, react_1.useEffect)(() => {
            return () => {
                setProfitPercent("");
                setInputValue("");
                setIsChanged(false);
                setLabelText("");
            };
        }, []);
        const visibleItem = (0, react_1.useMemo)(() => {
            return orderInfo ? [orderInfo] : [];
        }, [orderInfo]);
        const tickerMap = (0, Global_1.useBotOrdersTickerWebsocket)((_a = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.exchange) !== null && _a !== void 0 ? _a : TradeAPILib_1.ExchangeID.PIONEXV2, visibleItem, OrderCurrentTickerObserve, true);
        (0, react_1.useEffect)(() => {
            var _a, _b;
            const tickers = [];
            (_a = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.exchangeSROrder) === null || _a === void 0 ? void 0 : _a.coins.filter((a) => {
                return a.base !== orderInfo.quote && a.currentBaseAmount !== 0;
            }).forEach((item1) => {
                const tempTicker = tickerMap.get(`${orderInfo.exchange}/${item1.base}/${orderInfo.quote}`);
                if (tempTicker !== undefined) {
                    tickers.push(tempTicker);
                }
            });
            if (tickers.length ===
                ((_b = orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.exchangeSROrder) === null || _b === void 0 ? void 0 : _b.coins.filter((a) => {
                    return a.base !== (orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.quote) && a.currentBaseAmount !== 0;
                }).length)) {
                const tempExchangeOrder = TradeAPILib_1.TradeUtils.calcGridOrderProfit(orderInfo, 0, undefined, tickers);
                setProfitPercent(new trade_utils_lib_1.SafeDecimal(tempExchangeOrder.exchangeSROrder.totalProfitPercent).toFixed(2));
            }
        }, [orderInfo, tickerMap]);
        (0, react_1.useEffect)(() => {
            if (inputError === undefined) {
                switch (stopLimitType) {
                    case STOP_LIMIT_TYPE.PROFIT_PERCENTTAGE:
                        setLabelText($st("martingale_take_profit_percentage_hint", {
                            percent: $num(Math.max(0, new trade_utils_lib_1.SafeDecimal(profitPercent).toNumber()), {
                                style: "decimal",
                                sign: "auto",
                                precision: 1,
                            }),
                        }));
                        break;
                    case STOP_LIMIT_TYPE.LOSS_PERCENTTAGE:
                        setLabelText($st("martingale_stop_loss_percentage_hint", {
                            percent: -100,
                        }));
                        break;
                    default:
                        setLabelText("--");
                        break;
                }
            }
            else {
                setLabelText(inputError);
            }
        }, [inputError, stopLimitType, profitPercent, $st, $num]);
        (0, react_1.useEffect)(() => {
            if (isChanged) {
                return;
            }
            if (orderAction === OrderAction.CREATE && !orderInfo) {
                setInputValue(defaultValue !== null && defaultValue !== void 0 ? defaultValue : "");
                setInputDisplay(defaultValue
                    ? new trade_utils_lib_1.SafeDecimal(defaultValue).greaterThan(0)
                        ? "+" + new trade_utils_lib_1.SafeDecimal(defaultValue).toString()
                        : defaultValue
                    : stopLimitType === STOP_LIMIT_TYPE.PROFIT_PERCENTTAGE
                        ? "+"
                        : "-");
                return;
            }
            if (stopLimitType === STOP_LIMIT_TYPE.PROFIT_PERCENTTAGE) {
                if (!(0, lodash_1.isNil)(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.exchangeSROrder.stopProfitPercent)) {
                    const temp = new trade_utils_lib_1.SafeDecimal(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.exchangeSROrder.stopProfitPercent).mul(100);
                    setInputValue(temp.toString());
                    setInputDisplay(temp.greaterThan(0) ? "+" + temp.toString() : temp.toString());
                }
                else {
                    setInputValue("");
                    setInputDisplay("+");
                }
            }
            else {
                if (!(0, lodash_1.isNil)(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.exchangeSROrder.stopLossPercent)) {
                    const temp = new trade_utils_lib_1.SafeDecimal(orderInfo === null || orderInfo === void 0 ? void 0 : orderInfo.exchangeSROrder.stopLossPercent).mul(100);
                    setInputValue(temp.toString());
                    setInputDisplay(temp.greaterThan(0) ? "+" + temp.toString() : temp.toString());
                }
                else {
                    setInputValue("");
                    setInputDisplay("-");
                }
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [orderInfo, stopLimitType, orderAction, defaultValue]);
        const onTextChange = (0, react_1.useCallback)((text) => {
            setIsChanged(true);
            if (/[,。]/.test(text)) {
                if (!/\./.test(text)) {
                    text = text.replace(/[,。]/, ".");
                }
            }
            const { error, display, value } = checkValidity(text, {
                stopLimitType,
                orderAction,
                profitPercent,
                isChanged: true,
                $st,
                $num,
            });
            setInputValue(value);
            setInputDisplay(display);
            setInputError(error);
        }, [stopLimitType, orderAction, profitPercent, $st, $num]);
        return { onTextChange, inputValue, inputDisplay, labelText, inputError, profitPercent };
    }
    SRStopLossProfitPercent.useStopLossProfitPercent = useStopLossProfitPercent;
})(SRStopLossProfitPercent || (exports.SRStopLossProfitPercent = SRStopLossProfitPercent = {}));
